/** Shared status pill colour map for the messages admin page. */
export const STATUS_OPTIONS = ["new", "read", "archived"];

export const STATUS_STYLES = {
    new: "bg-[#fdf6e8] text-[#8a6a1f] border-[#C8A24A]/30",
    read: "bg-[#e9efe5] text-[#0E2A47] border-[#0E2A47]/25",
    archived: "bg-[#EFEBE0] text-[#6F6B63] border-[#E5DFD3]",
};
